import InfiniteScroll from "./infiniteScroll";

class CategoryDropdown {
  infiniteScroll = null;
  categorySearch;
  dropdown;
  selected;

  constructor(infiniteScrollInstance, container) {
    this.infiniteScroll = infiniteScrollInstance;
    this.container = container;
  }

  handleToggleDropdown = () => {
    this.categorySearch.addEventListener("click", (e) => {
      this.dropdown.classList.toggle("hidden");
      this.categorySearch.classList.toggle("open");
    });
  };

  handleChangeCategory = () => {
    this.dropdown.addEventListener("click", (e) => {
      e.preventDefault();
      if (e.target.tagName === null) console.log(e);
      if (
        (e.target.tagName.toUpperCase() === "A" ||
          e.target.tagName.toUpperCase() === "BUTTON") &&
        !e.target.classList.contains("active")
      ) {
        const category = e.target;
        const currentActive = this.categorySearch.querySelector(".active");
        currentActive && currentActive.classList.remove("active");

        category.classList.add("active");
        this.selected.innerHTML = category.innerHTML;

        if (typeof this.infiniteScroll === "object") {
          category.href &&
            history.replaceState(undefined, undefined, category.href);

          this.infiniteScroll.destroy();

          this.infiniteScroll = new InfiniteScroll(this.container, {
            fetchUrl: wtm_global_vars._wtm_rest + category.dataset.endpoint,
            type: "html",
            currentPage: 0,
          });

          this.infiniteScroll.init();
          this.infiniteScroll.fetchData();
        }
      }
    });
  };

  init = () => {
    this.categorySearch = document.querySelector(".category-search");
    this.dropdown = this.categorySearch.querySelector(".dropdown");
    this.selected = this.categorySearch.querySelector(".selected span");

    this.handleToggleDropdown();
    this.handleChangeCategory();
  };
}

export default CategoryDropdown;
